// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';

import { BootstrapVue } from 'bootstrap-vue';
// import { BNavbar, BButton, BLink, BContainer, BCol, BRow, BAlert, BNavbarToggle, BCollapse, BNavbarBrand, BNavbarNav, BModal, BCard, BForm, BFormGroup, BFormInput, BTable, VBToggle } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import Loader from '@/components/widgets/Loader';
import VueMasonry from 'vue-masonry-css';
// import VueGtm from 'vue-gtm';

import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faMousePointer, faEye, faUser, faChevronLeft, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faUpload, faFile, faTimes, faQuestion, faDollarSign, faMobile, faEnvelope, faThumbtack, faBars, faSignOutAlt, faSyncAlt, faSquareFull, faHourglass, faPoundSign, faExpand, faClone, faAddressCard, faBell, faTrashAlt, faCaretLeft, faExternalLinkAlt, faHeart } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faTwitter, faBehance } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import SocketIO from 'socket.io-client';
// import VueSocketIO from 'vue-socket.io';

// const options = { path: '/my-app/' }; // Options object to pass into SocketIO

// Vue.use(new VueSocketIO({
//   debug: true,
//   connection: SocketIO(process.env.SOCKET_ADDRESS), // options object is Optional
//   vuex: {
//     store,
//     actionPrefix: 'SOCKET_',
//     mutationPrefix: 'SOCKET_',
//   },
// }),
// );

library.add(faHeart, faMousePointer, faEye, faExternalLinkAlt, faCaretLeft, faTrashAlt, faBehance, faBell, faAddressCard, faClone, faExpand, faPoundSign, faHourglass, faSquareFull, faSyncAlt, faBars, faSignOutAlt, faMobile, faEnvelope, faThumbtack, faDollarSign, faUser, faInstagram, faTwitter, faFacebook, faChevronLeft, faCheck, faCreditCard, faCaretDown, faFileInvoiceDollar, faEllipsisV, faChevronRight, faPlus, faHome, faTruck, faTshirt, faKey, faFileCsv, faShoppingCart, faThumbsUp, faThumbsDown, faUpload, faCheck, faFile, faTimes, faQuestion);
Vue.component('font-awesome-icon', FontAwesomeIcon);

dom.watch();
Vue.config.productionTip = false;

// Vue.directive('v-b-toggle', VBToggle);
// Vue.component('b-navbar', BNavbar);
// Vue.component('b-button', BButton);
// Vue.component('b-link', BLink);
// Vue.component('b-container', BContainer);
// Vue.component('b-col', BCol);
// Vue.component('b-row', BRow);
// Vue.component('b-alert', BAlert);
// Vue.component('b-navbar-toggle', BNavbarToggle);
// Vue.component('b-navbar-brand', BNavbarBrand);
// Vue.component('b-navbar-nav', BNavbarNav);
// Vue.component('b-collapse', BCollapse);
// Vue.component('b-modal', BModal);
// Vue.component('b-card', BCard);
// Vue.component('b-form', BForm);
// Vue.component('b-form-group', BFormGroup);
// Vue.component('b-form-input', BFormInput);
// Vue.component('b-table', BTable);
Vue.use(BootstrapVue);
Vue.use(Loader);
Vue.use(VueMasonry);

// Vue.use(VueGtm, {
//   id: 'GTM-TT3WWHZ', // Your GTM single container ID or array of container ids ['GTM-xxxxxxx', 'GTM-yyyyyyy']
//   debug: true, // Whether or not display console logs debugs (optional)
//   vueRouter: router, // Pass the router instance to automatically sync with router (optional)
//   ignoredViews: [], // If router, you can exclude some routes name (case insensitive) (optional)
// });

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js